package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "ja")
val JaStrings = Strings(
    analyzer = "アナライザー",
    appreciationOverview = "評価概要",
    chartLegendInterest = "利息",
    chartLegendPrincipal = "元金",
    chartXaxisMonths = "月数",
    chartYaxisPayment = "支払い",
    code = "ja",
    costOfCredit = "信用のコスト",
    creditDealAnalyzerDescription = "ローンの詳細を入力して、信用取引の包括的な分析を受け取ります。私たちのアナライザーは、ローンの真のコストを理解し、情報に基づいた決定を下すのに役立つ主要な指標を評価します。",
    detailsGoodRateLongTerm = "良い金利ですが、期間が長いため総コストが高くなります。",
    detailsHighApr = "高い実質年率。 ",
    detailsHighInterestCost = "高い総利息コスト。",
    detailsHighRateShortTerm = "高い金利ですが、期間が短いため総コストは低く抑えられています。",
    detailsLowApr = "低い実質年率。 ",
    detailsLowInterestCost = "低い総利息コスト。",
    discountsTradeIn = "割引 / 下取り",
    displayName = "日本語",
    distribution = "分布",
    downPayment = "頭金",
    effectiveApr = "実質年率",
    headerBalance = "残高",
    headerDate = "日付",
    headerInterest = "利息",
    headerMonth = "#",
    headerPayment = "支払い",
    headerPrincipal = "元金",
    hideDetails = "詳細を隠す",
    interest = "利息",
    invalidData = "無効なデータ",
    loanAmountSupportingText = "追加費用を含むローンの総額。",
    loanDetails = "ローンの詳細",
    paymentSupportingText = "推定月額支払い。",
    paymentComposition = "支払いの構成",
    percentSymbol = "%",
    principal = "元金",
    ratingBad = "悪い取引",
    ratingExcellent = "素晴らしい取引",
    ratingFair = "公正な取引",
    ratingGood = "良い取引",
    ratingPoor = "貧弱な取引",
    schedule = "スケジュール",
    showDetails = "詳細を表示",
    summaryBad = "非常に不利です。可能であれば避けてください。",
    summaryExcellent = "素晴らしい財務条件。",
    summaryFair = "公正な条件。交渉を検討してください。",
    summaryGood = "良い条件。市場の標準です。",
    summaryPoor = "貧弱な条件。高いコストまたは金利。",
    totalPaid = "支払総額",
    lockTaxRate = "税率をロック",
    unlockTaxRate = "税率のロックを解除",
    currencySymbol = "¥",
    currency = "通貨",
    totalCreditAmount = "信用の総額",
    taxAmount = "税金/控除額",
    netAmountDisbursed = "純支払額",
    years = "年",
    loanTermTotalMonths = "ローン期間（月）",
    monthlyInstallment = "月々の分割払い",
    principalInstallment = "元金の分割払い",
    otherFees = "その他の手数料",
    insuranceCost = "保険料",
    aprc = "実質年率 (APRC)",
    totalAmountPayable = "支払総額",
    prepaidFeeFixed = "事務手数料（固定額）",
    prepaidFeePercentage = "事務手数料（パーセンテージ）",
    months = "月",
    description = "このアナライザーは、ローンのオファーがあなたにとって有利かどうかを評価するのに役立ちます。標準的な計算機とは異なり、金利の入力は必要ありません。代わりに、支払いと手数料に基づいて実質年率と信用の総コストを計算し、取引の評価と詳細なチャートを提供します。",
    agree = "同意する",
    information = "情報",
    errorCalculationOverflow = "APRが高すぎるため、計算がオーバーフローしました。",
    errorTotalPaymentIsLessThanLoanAmount = "受取額が融資額より少ないです。",
    errorDivisionByZero = "ゼロ除算",
    errorNegativeResult = "負の結果",
    errorRateTooHigh = "レートが高すぎます",
    errorCalculation = "正しいデータを入力してください",
    close = "閉じる",

    hi = "こんにちは",
    guest = "ゲスト",
    account = "アカウント",
    signInWithGoogle = "Googleでログイン",
    signOut = "ログアウト",
    settings = "設定",
    about = "アプリについて",
    privacyPolicy = "プライバシーポリシー",
    termsOfService = "利用規約",
    language = "言語",

    theme = "テーマ",
    light = "ライト",
    dark = "ダーク",
    system = "システム",
    toggleExpand = "展開/折りたたみ",
)
